import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState, CrudlStatus } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class PartDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div
        className="ui-g-12 card-round"
        onClick={e => {
          if (format.isFunction(this.props.onClick)) {
            this.props.onClick(CrudlStatus.VIEW, bean);
          }
        }}
      >
        <div className="ui-g-12">
          <h2>Part Summary: </h2>
          <label />

          <div className="ui-g-2 row"></div>
          <div className="ui-g-8 row">
            <div className="ui-g-8 cell">
              <b style={{ float: "right" }}>Name: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Description: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Long Description: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>SKU: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Operational Type: </b>
            </div>

            <div className="ui-g-8 cell">
              <label>{bean.name || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.shortDescription || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.longDescription || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.sku || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.operationalType || "Not Set"}</label>
            </div>
            <div className="ui-g-8 cell">
              <b style={{ float: "right" }}>Stock Type: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Price: </b>
              <br></br>
              <br></br>
              <b style={{ float: "right" }}>Cost: </b>
            </div>

            <div className="ui-g-8 cell">
              <label>{bean.stockType || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.price || "Not Set"}</label>
              <br></br>
              <br></br>
              <label>{bean.cost || "Not Set"}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Part/UI/PartDisplay.js